export type DocumentTypes =
  | 'TAX_CODE'
  | 'LAW'
  | 'GOVERNMENT_DECISION'
  | 'MINISTERIAL_ORDER'
  | 'INSTRUCTION'
  | 'REGULATION'
  | 'DECISION'
  | 'ORDER'
  | 'INTERNATIONAL_TREATY'
  | 'OTHER';

export type DocumentStatuses = 'ACTIVE' | 'REPEALED';

export type DocumentVersionStatuses = 'ACTIVE' | 'MODIFIED' | 'REPEALED';

export type DocumentCategories =
  | 'PROFIT_TAX'
  | 'VAT'
  | 'EXCISE_TAX'
  | 'PROPERTY_TAX'
  | 'SIMPLIFIED_TAX'
  | 'PATENT_SYSTEM'
  | 'SOCIAL_CONTRIBUTIONS'
  | 'PENSION_CONTRIBUTIONS'
  | 'TAX_REPORTING'
  | 'TAX_CONTROL'
  | 'TAX_AUDIT'
  | 'ADMINISTRATIVE_LIABILITY'
  | 'TAX_VIOLATIONS'
  | 'CUSTOMS_PAYMENTS'
  | 'INTERNATIONAL_TAXATION'
  | 'TAX_TREATIES'
  | 'TAX_PROCEDURE'
  | 'APPEALS'
  | 'GENERAL_QUESTIONS';

export enum DocumentLangs {
  KY = 'KY',
  RU = 'RU',
}

export type DocumentPayload = {
  documentNumber: string;
  acceptanceDate?: string;
  publicationDate?: string;
  entryIntoForceDate?: string;
  // language: DocumentLangs;
  type: DocumentTypes;
  categoryIds: number[];
  status: DocumentStatuses;
  versionDate: string;
  validFrom?: string | null;
  validTo?: string | null;
};

export type DocumentMetaData = {
  documentNumber: string;
  type: DocumentTypes;
  acceptanceDate?: string;
  publicationDate?: string;
  entryIntoForceDate?: string;
  categoryIds: number[];
  thematic?: string;
  officialSourceUrl?: string;
  version: {
    acceptanceDate: string;
    versionNumber: string;
    versionDate: string;
    validFrom?: string | null;
    validTo?: string | null;
    changeDescription: string;
    documentVersionStatus: DocumentVersionStatuses;
    contents: {
      language: DocumentLangs;
      title: string;
      content: string;
    }[];
  };
};

export type DocumentDto = {
  id: number;
  documentNumber: string;
  // TODO: add enum
  type: string;
  acceptanceDate: string | null;
  publicationDate: string;
  entryIntoForceDate: string;
  // TODO: add enum
  status: string;
  thematic: string;
  officialSourceUrl: string;
  categoryIds: number[];
  activeVersion: DocumentVersionDto | null;
};

export type PublicDocumentDto = {
  documentId: number;
  lastVersionId: number;
  documentNumber: string;
  title: string;
  type: string;
  versionCount: number;
  status: 'ACTIVE' | 'REPEALED';
  createDate: string;
};

type FileType = 'ORIGINAL' | 'PROCESSED';
type FileFormat = 'PDF' | 'DOCX' | 'DOC' | 'HTML' | 'TXT';

export type DocumentFileDto = {
  id: number;
  versionId: number;
  originalFileName: string;
  fileType: FileType;
  format: FileFormat;
  language: DocumentLangs;
  fileSize: number;
  downloadUrl: string;
  uploadDate: string;
  uploadedBy: string;
};

export type DocumentFileData = {
  fileType: FileType;
  format: FileFormat;
  language: DocumentLangs;
};

// export type DocumentSectionDto = {
//   id: string;
//   sectionCode: string;
//   sectionType: string;
//   title: string;
//   content: string;
//   orderIndex: number;
//   depth: number;
//   parentSectionId: number;
// };

export type DocumentsFilter = {
  title?: string | null;
  documentNumber?: string | null;
  content?: string | null;
  types?: DocumentTypes[] | null;
  statuses?: DocumentStatuses[] | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  lang?: DocumentLangs;
  sortBy?: DocumentSortField;
};

export type DocumentSortField = 'updatedAt' | 'createDate';

export type DocumentVersionDto = {
  id: number;
  documentId: number;
  versionNumber: string;
  acceptanceDate: string;
  versionDate: string;
  validFrom?: string | null;
  validTo?: string | null;
  documentVersionStatus: DocumentVersionStatuses;
  workflowStatus: string;
  changeDescription: string;
  contents: DocumentContent[];
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};

export type DocumentContent = {
  id?: number;
  updatedAt?: string;
  language: string;
  title: string;
  content: string;
};

export type DocumentVersionEditData = {
  versionNumber?: string;
  versionDate?: string;
  validFrom?: string | null;
  validTo?: string | null;
  changeDescription?: string;
  documentVersionStatus?: DocumentVersionStatuses;
  contents?: DocumentContent[];
};

export type DocumentEditData = {
  documentNumber?: string;
  type?: string;
  acceptanceDate?: string;
  publicationDate?: string;
  status?: string;
  categoryIds?: number[];
};
